<template>
  <d-container fluid>
    <d-row>
      <d-col class="main-content p-0" tag="main" lg="12" md="12" sm="12">

        <!-- Content -->
        <slot />

        <!-- Main Footer -->
        <main-footer class="home-footer" />
      </d-col>

    </d-row>
  </d-container>
</template>

<script>

// Main layout components
import MainNavbar from '@/components/layout/MainNavbar/MainNavbar.vue';
import MainFooter from '@/components/layout/MainFooter/MainFooter.vue';

export default {
  name: 'analytics',
  components: {
    MainNavbar,
    MainFooter,
  },
};
</script>
<style lang="scss" scoped>
    .home-footer{
        position: fixed;
        bottom: 0;
        width: 100%;
        .nav{
            display: flex !important;
        }
    }
</style>
